module.exports = __webpack_public_path__ + "static/media/neroli.551d836b.png";